/**
 * Order totals aligned with n8n config (partner discount when applyPartnerDiscount).
 */

import { normalizeCheckoutConfig } from "./checkoutFormConfig";

export function getEffectivePartnerDiscountRate(config) {
  const c = normalizeCheckoutConfig(config);
  if (!c || !c.applyPartnerDiscount) return 0;
  const r = c.partnerCommissionRate;
  if (typeof r === "number" && !Number.isNaN(r) && r > 0) return r;
  const d = c.discount;
  if (typeof d === "number" && !Number.isNaN(d) && d > 0) return d;
  return 0;
}

/**
 * @returns {{ deliveryFee: number, totalDiscount: number, totalPriceDisplay: number, totalPriceHT: number, partnerCommissionPercent: number|undefined }}
 */
export function computeOrderTotals(config, totalItemPriceTTC) {
  const c = normalizeCheckoutConfig(config);

  let deliveryFee = 0;
  if (c.applyDeliveryFee) {
    deliveryFee =
      c.deliveryFreeThreshold > 0 &&
      totalItemPriceTTC >= c.deliveryFreeThreshold
        ? 0
        : c.deliveryCost;
  }

  let totalDiscount = 0;
  if (c.applyPartnerDiscount) {
    const rate = getEffectivePartnerDiscountRate(c);
    totalDiscount = totalItemPriceTTC * rate;
  }

  const totalPriceDisplay = totalItemPriceTTC + deliveryFee - totalDiscount;
  const totalPriceHT =
    totalItemPriceTTC / 1.2 + deliveryFee / 1.2 - totalDiscount;

  const rate = getEffectivePartnerDiscountRate(c);
  const partnerCommissionPercent =
    c.applyPartnerDiscount && rate > 0
      ? c.partnerCommissionPercent != null
        ? Number(c.partnerCommissionPercent)
        : Math.round(rate * 100)
      : undefined;

  return {
    deliveryFee,
    totalDiscount,
    totalPriceDisplay,
    totalPriceHT,
    partnerCommissionPercent,
  };
}
